import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from './TrendStatCard.module.scss';

// Sparkline pattern forked from DashboardOverviewNew's TeamPerformance
// Sparkline (recharts <LineChart>, no axes/grid/tooltip) — that component is
// view-local to a different page, so this is a fresh, generalized version
// rather than a cross-view import.
export const TrendStatCardComponent = ({
  title,
  tooltip,
  value,
  tint,
  sparklineColor,
  sparklineData,
  deltaPct,
  deltaDirection = 'up',
  // Whether the arrow's direction is itself the good outcome — e.g. "up" is
  // good for a completed-tasks count, but bad for a lateness count (an
  // increase there should still read as a warning, not a win). Defaults to
  // 'positive' so every existing caller (which never passed this) keeps
  // rendering exactly as before: up = green, down = red.
  deltaSentiment = 'positive',
  deltaSuffix = '%',
  icon,
  iconBg,
}) => {
  const chartData = (sparklineData || []).map((v, i) => ({ i, v }));
  const isUp = deltaDirection === 'up';
  const isGood = deltaSentiment === 'positive' ? isUp : !isUp;

  return (
    <div className={styles.card} style={{ background: `var(--${tint})` }}>
      {icon && (
        <div className={styles.iconWrap} style={{ backgroundColor: iconBg }}>
          {icon}
        </div>
      )}
      <div className={styles.cardTitle}>
        <span>{title}</span>
        {tooltip && <InfoTooltip title={title} description={tooltip} />}
      </div>

      {chartData.length > 0 && (
        <div className={styles.sparklineWrapper}>
          <ResponsiveContainer width="100%" height={40}>
            <LineChart data={chartData}>
              <Line
                type="monotone"
                dataKey="v"
                stroke={`var(--${sparklineColor})`}
                strokeWidth={1.5}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      <div className={styles.value}>{value}</div>

      {deltaPct != null && (
        <div className={styles.deltaRow}>
          {isUp ? (
            <FiArrowUp size={12} className={isGood ? styles.up : styles.down} />
          ) : (
            <FiArrowDown
              size={12}
              className={isGood ? styles.up : styles.down}
            />
          )}
          <span className={isGood ? styles.up : styles.down}>
            {deltaPct}
            {deltaSuffix}
          </span>
          <span className={styles.vsLabel}>vs yesterday</span>
        </div>
      )}
    </div>
  );
};

TrendStatCardComponent.displayName = 'TrendStatCard';
